import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { OrderStatusPublic } from './Enums'
/**
* Class StatusInfoOfOrderStatusPublic
*  Информация о статусе
*/
export class StatusInfoOfOrderStatusPublic extends ActiveModel {

  /**
  * status
  * словарь значений публикуется под именем `Domain.Entities.Orders.OrderStatusPublic`  *   * Значение статуса<br>  *   * - `Calculated` Ожидает оплаты  *   * Ожидает оплаты  * - `Payment` В процессе оплаты  *   * В процессе оплаты  * - `Collection` Собирается  *   * В процессе сбора  * - `Delivery` В процессе доставки  *   * В процессе доставки  * - `Receiving` Ожидает получения  *   * Ожидает получения  * - `Cancelling` В процессе отмены  *   * В процессе отмены  * - `Completing` В процессе завершения  *   * В процессе завершения  * - `Cancelled` Отменён  *   * Отменён  * - `Completed` Завершён  *   * Завершён  *   */
  @ActiveField(OrderStatusPublic.CALCULATED)
  status: OrderStatusPublic = OrderStatusPublic.CALCULATED


/**
  * assignedAt
  * Время назначения статуса<br>
  */
  @ActiveField('')
  assignedAt: string = ''
}
